import React from 'react';
import { AnnouncementBar } from './components/AnnouncementBar';
import { HeroSection } from './components/HeroSection';
import { StatsBar } from './components/StatsBar';
import { TransformationSection } from './components/TransformationSection';
import { PainPointsSection } from './components/PainPointsSection';
import { CollectionsSection } from './components/CollectionsSection';
import { FrameworkSection } from './components/FrameworkSection';
import { InstantAccessSection } from './components/InstantAccessSection';
import { BonusesSection } from './components/BonusesSection';
import { PricingSection } from './components/PricingSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { FAQSection } from './components/FAQSection';
import { FinalCTASection } from './components/FinalCTASection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen w-full overflow-x-hidden bg-brand-main font-sans text-brand-text selection:bg-brand-orange/25" data-id="element-0" data-mp="3ijxpqrsp22kf">
      <AnnouncementBar data-id="element-1" data-mp="3mkre1ma1tjdu" />
      <main data-id="element-2" data-mp="3mk83iqmq9x9u">
        <HeroSection data-id="element-3" data-mp="3mjq2lgp4euvl" />
        <StatsBar data-id="element-4" data-mp="3mj6jhwnqi0fz" />
        <TransformationSection data-id="element-5" data-mp="3rcj31sdk3h1v" />
        <PainPointsSection data-id="element-6" data-mp="3rdkisa5iorpx" />
        <CollectionsSection data-id="element-7" data-mp="3recdzjv7cnfo" />
        <FrameworkSection data-id="element-8" data-mp="5ott78p769p" />
        <InstantAccessSection data-id="element-9" data-mp="4wv3njt0sf7" />
        <BonusesSection data-id="element-10" data-mp="56m9egl55mh" />
        <PricingSection data-id="element-11" data-mp="2zl3alhpbj03q" />
        <GuaranteeSection data-id="element-12" data-mp="2zllijblcf2rh" />
        <TestimonialsSection data-id="element-13" data-mp="2zmemk4sx3e5x" />
        <FAQSection data-id="element-14" data-mp="2zng1ikd20ksx" />
        <FinalCTASection data-id="element-15" data-mp="33mf2jtvnzxf3" />
      </main>
      <Footer data-id="element-16" data-mp="33ngee0ki8nxv" />
    </div>;
}